
import { defineComponent } from "vue";
import Hero from "@/components/Hero.vue";
import PageContainer from "@/components/PageContainer.vue";
import PageContent from "@/components/PageContent.vue";
import PageTitle from "@/components/PageTitle.vue";
import FollowFestival from "@/components/FollowFestival.vue";

export default defineComponent({
  components: {
    Hero,
    PageContainer,
    PageContent,
    PageTitle,
    FollowFestival,
  },
  setup() {
    return {
      baseURL: process.env.BASE_URL,
    };
  },
});
